import React from "react"
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Spinner } from "../common/Spinner";

export enum FileUploadPreviewStatus {
    LOADING,
    UPLOADED
}

export interface FileUploadPreviewProps {
    id: number;
    status: FileUploadPreviewStatus,
    name: string;
    onRemoveClick: () => void;
}

export const FileSendPreview: React.FC<FileUploadPreviewProps> = (props) => {
    return (
        <div className={`w-[90px] h-[90px] rounded-lg flex 
        align-middle relative flex-col bg-gray-200 overflow-hidden`}>
            <div className="w-full flex flex-row justify-center mt-6">
            <InsertDriveFileOutlinedIcon style={{width: "30px", height: "30px"}} />
            </div>
            {props.status === FileUploadPreviewStatus.LOADING &&
                <div className="absolute w-full h-full flex align-middle justify-center items-center backdrop-blur-sm z-20">
                <Spinner size="small"/>
                </div>
            }
            <div className="absolute rounded-full bg-white right-1 top-1 w-[24px] h-[24px] flex justify-center items-center cursor-pointer" onClick={() => props.onRemoveClick()
            }>
                <CloseOutlinedIcon style={{width: "20px", height: "20px"}}/>
            </div>
            <div className="pl-1">{props.name}</div>
        </div>
    )
}